module.exports = __webpack_public_path__ + "static/media/search_fff.6c8f123f.svg";